// Bileli · modules/media/lib — persisted finalize targets. why: the lesson-draft flow creates the lesson
// at ticket time and navigates away, so no mounted view would otherwise drive the asset PENDING → READY.
// The global finalize driver reads this (reload-safe) and knows which course/lesson to refresh after.

import type { MediaKind } from '../model/media.types';

import { lsRead, lsSubscribe, lsWrite, MEDIA_TTL_MS } from './lsUtil';

const KEY = 'bileli:pending-media-finalize';
const EVENT = 'bileli:pending-media-finalize:changed';

export interface PendingFinalizeEntry {
  assetId: string;
  kind: MediaKind;
  courseId: string;
  lessonId?: string;
  createdAt: number;
}

export function listPendingFinalize(now = Date.now()): PendingFinalizeEntry[] {
  const all = lsRead<PendingFinalizeEntry[]>(KEY) ?? [];
  const fresh = all.filter((e) => e && e.assetId && now - e.createdAt < MEDIA_TTL_MS);
  if (fresh.length !== all.length) lsWrite(KEY, fresh, EVENT);
  return fresh;
}

export function savePendingFinalize(draft: Omit<PendingFinalizeEntry, 'createdAt'>): void {
  const rest = listPendingFinalize().filter((e) => e.assetId !== draft.assetId);
  lsWrite(KEY, [...rest, { ...draft, createdAt: Date.now() }], EVENT);
}

export function clearPendingFinalizeByAssetId(assetId: string): void {
  lsWrite(KEY, listPendingFinalize().filter((e) => e.assetId !== assetId), EVENT);
}

export function subscribePendingFinalize(listener: () => void): () => void {
  return lsSubscribe(KEY, EVENT, listener);
}
